import { ModelToggle } from '../types';
export const modelToggleEngagementAdapter = (
  modelToggleData: ModelToggle = {
    mixedGrid: false,
    sizeValue: '',
  }
): string => {
  const { mixedGrid = false, sizeValue = false } = modelToggleData;
  if (mixedGrid) {
    return 'modelOn=size all';
  }
  return sizeValue ? `modelOn=size ${sizeValue}` : '';
};
